import { TEMPLATE_PERMISSIONS } from '@hubertai/screening-question-types';
import type { TVisibility } from 'types/template/template.types';
import type { TAdminUser, TRecruiterAppUser } from 'types/user.types';
import { isRecruiterUser, userHasPermission } from 'types/user.types';

type TUser = TAdminUser | TRecruiterAppUser | undefined | null;

export function revisionLacksSharingPermission(user: TUser, sourceVisibility: TVisibility | undefined): boolean {
  return (
    isRecruiterUser(user) && sourceVisibility === 'client' && !userHasPermission(user, TEMPLATE_PERMISSIONS.ShareOrg)
  );
}
